import { FC, useCallback } from 'react';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';

import { ExpansionContext, ExpansionState } from './context';
import { ExpandModes } from './types';

export type ContextProps = {
  initialMode?: ExpandModes;
  localKey?: string;
};

export const ExpansionContextProvider: FC<React.PropsWithChildren<ContextProps>> = ({
  initialMode = ExpandModes.default,
  localKey = 'expansion-context',
  children,
}) => {
  const [mode, setMode] = useLocalStorage<ExpandModes>(localKey, initialMode);

  const collapse = useCallback(() => setMode(ExpandModes.collapse), []);

  const expand = useCallback(() => setMode(ExpandModes.expand), []);

  const reset = useCallback(() => setMode(ExpandModes.default), []);

  const toggle = useCallback(
    () =>
      setMode((current) =>
        current === ExpandModes.collapse ? ExpandModes.expand : ExpandModes.collapse,
      ),
    [],
  );

  const contextValue: ExpansionState = {
    collapse,
    expand,
    mode,
    reset,
    toggle,
  };
  return <ExpansionContext.Provider value={contextValue}>{children}</ExpansionContext.Provider>;
};
